// extracted by mini-css-extract-plugin
export var editInput = "_k2-0";
export var editInputCompact = "_k2-2";
export var editInputLarge = "_k2-1";
export var editInputSmall = "_k2-3";